module.exports = __webpack_public_path__ + "static/img/nocartd.a86f53f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nocartd.png
// module id = /1jm
// module chunks = 1